import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { uploadReadyGuard } from './core/guards/upload-ready.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'upload', pathMatch: 'full' },
  {
    path: 'upload',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./features/upload/upload.component').then(
        (m) => m.UploadComponent
      ),
  },
  {
    path: 'discovery',
    canActivate: [MsalGuard, uploadReadyGuard],
    loadComponent: () =>
      import('./features/data-discovery/data-discovery.component').then(
        (m) => m.DataDiscoveryComponent
      ),
  },
  {
    path: 'interval',
    canActivate: [MsalGuard, uploadReadyGuard],
    loadComponent: () =>
      import('./features/interval-builder/interval-builder.component').then(
        (m) => m.IntervalBuilderComponent
      ),
  },
  {
    path: 'clustering',
    canActivate: [MsalGuard, uploadReadyGuard],
    loadComponent: () =>
      import('./features/clustering/clustering.component').then(
        (m) => m.ClusteringComponent
      ),
  },
  {
    path: 'normalization',
    canActivate: [MsalGuard, uploadReadyGuard],
    loadComponent: () =>
      import('./features/normalization/normalization.component').then(
        (m) => m.NormalizationComponent
      ),
  },
  {
    path: 'export',
    canActivate: [MsalGuard, uploadReadyGuard],
    loadComponent: () =>
      import('./features/export/export.component').then(
        (m) => m.ExportComponent
      ),
  },
  { path: '**', redirectTo: 'upload' },
];